import { EnvConfigReceiptLookup } from '../interfaces/env-interfaces';

/**
 * The configuration is used throughout the application to determine how to connect
 * to the backend services and to set up the application prod environment.
 */
export const environment: EnvConfigReceiptLookup = {
    production: true,
    useLock: true,
    appConfig: {
        envRegion: 'eu-west-1',
        envType: 'prod',
        apiBaseUrl: 'chargeye.io',
        appBaseHostname: 'receipts.chargeye.io',
    },
    waf: {
        /** CAPTCHA site key for AWS WAF, used for Javascript integration
         * Please note that this is not a secret, it's safe to expose in the frontend code
         * the key is only used for specific domain and the actual validation is done in AWS WAF
         */
        captchaSiteKey:
            'myqqJ3k7nErpDKIypuAHqwcgqQkZJHOtRv2IaiSUv+aMkMXrA9THGh1ZZI0+13CB/1jxy2fPESs280TG2EckK0qwoSpRc/TFuG0dNO3ni2VSuBFNUob1jkKecvE0lUmK/l8QD92nOMo+kTCmjeWED0vlv+qcRptPrkzyLFRO7MhE9DmYkb1epizyot15adlqSKtnWTWeRu9zjnAHW5ySIu8xQ30e8qQo439iplDknrEaJ1j0Kou7IOsHSkWl+xI0exrVLgLtBreHdzczPzBwoJ96ZQ7D4wuJzvN20Awb+nylKHx0we1ABYEnWvSJlBOFNE7rieYj7BBaLZaUrdYxOP5xE1WuXgKZC7+Cd6rEZbDSy/qDSC/9I9AS4Kfi18F0rOmUqzu2loCQrafWu7Qi0zwHO+PIBQ+GdXcohodifHPfIZGWwkitPSI6I3aFM9mLIzTswW8wsCBr5U80s/SINQhrYXX3ntqJ3WPgOsw+XJkSgBjANgpVMRkM/NGjiTdUBakfmkDnm0qKdFawxCc0aDOfGqmsCzXDhFCrFZ1sRsTu9ezEkLFgb9NhWkfmgJ5/fDbxCFEpBh+5ijQ1/k5br4F80/TiqL7RR2d0KCTZ7YUIoxJMvMa59kSaknI9fqo/QfJhbBFH4L9ST+J32Lq5wkTRI27au3uFOynpLouedCM=_0_1',
        captchaScriptUrl: 'https://1c9f86b1890d.eu-west-1.captcha-sdk.awswaf.com/1c9f86b1890d/jsapi.js',
    },
};
